<template>
  <div id="blog-page">
    <vs-card>
      <div class="vx-row mb-12">
        <div class="vx-col w-1/3">
          publish date
          <!-- <datepicker format="yyyy-MM-dd 00:00:00" placeholder="Select Date" v-model="params.UpdatedOn"></datepicker> -->
          <flat-pickr :config="configFromdateTimePicker" v-model="params.UpdatedOn" placeholder="Select range" ref="programaticOpen"/>
        </div>        
        <div class="vx-col w-1/3">
          <vs-button @click="updateData()" color="primary" type="filled">Save</vs-button>
        </div>
        <div class="vx-col w-1/3">
          <vs-switch color="success" v-model="isPublished">
              <span slot="on">Published</span>
              <span slot="off">Draft</span>
          </vs-switch>        
        </div>
      </div>
      <vs-tabs>
      <vs-tab label="Content">
        <div class="vx-row mb-6">
          <div class="vx-col w-1/2">
            Page Title
            <vs-input class="inputx w-1/2" v-model="params.pageTitle" />
          </div>
          <div class="vx-col w-1/2">
            Page Description
            <vs-input class="inputx w-1/2" v-model="params.pageDescription" />
          </div>
        </div>      
        <ckeditor v-model="params.pageContent" :config="editorConfig"></ckeditor>
      </vs-tab>
      <vs-tab label="SEO">
        <div class="vx-row mb-6">
          <div class="vx-col w-1/2">
            Page url
            <vs-input class="inputx w-1/2" v-model="params.pageUrl" />
          </div>
          <div class="vx-col w-1/2">
            SEO Title
            <vs-input class="inputx w-1/2" v-model="params.seoTitle" />
          </div>
          <div class="vx-col w-1/2">
            SEO Description
            <vs-input class="inputx w-1/2" v-model="params.seoDescription" />
          </div>
        </div>
      </vs-tab>
      <vs-tab label="Galllery">
        <gallery />
      </vs-tab>      
    </vs-tabs>                  
    </vs-card>
  </div>
</template>

<script>
import axios from "@/axios.js"
import TableView from '../../components/tableView';
import Datepicker from 'vuejs-datepicker';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import CKEditor from 'ckeditor4-vue';
import Gallery from './gallery.vue';
export default {
  components: {
    TableView,
    ckeditor: CKEditor.component,
    Gallery,
    Datepicker,
    flatPickr
  },
  data() {
    let data = {
      params:{pageContent:'',pageName:'',pageTitle:'',pageDescription:'',isPublished:false},
      configFromdateTimePicker: {
        dateFormat: "d M, Y",        
      },
      componentKey: 0,
      endPoint:'/api/blog',      
      editorConfig: {
          // The configuration of the editor.
      }
    }
    return data;
  },
  computed: {    
    isPublished:{
      get: function(){
        return this.params.isPublished;
      },
      set: function(val){    
        if(val===true)
          this.params.isPublished = 'true';
        else
          this.params.isPublished = 'false'; 
        this.updateData();
        this.params.isPublished = this.params.isPublished==='true';
        this.publishPage();
      }
    }
  },
  methods: {    
    translate: function(key){
      return this.$t(key);
    },
    openAlert(color,title,text) {
      let colorAlert = color;
      this.$vs.notify({
          title: title,
          text: text,
          color: colorAlert
      })
    },
    getData: function(){
      let that = this;
      this.$vs.loading();      
      axios.get("/api/blog?page="+this.$route.params.page)
      .then((data) => {
        that.$vs.loading.close();
          that.params = data.data;
        })
      .catch(() => { that.$vs.loading.close(); that.openAlert('danger','Failed'); })
    },
    updateData: function(){
      let that = this;
      this.$vs.loading();
      axios.put("/api/blog",this.params)
      .then((data) => {
        that.$vs.loading.close();
        if(data.data.success){
          that.openAlert('success','Success');
        } else{
          that.openAlert('danger','Failed',data.messsage);
        }
        })
      .catch(() => { that.$vs.loading.close(); that.openAlert('danger','Failed'); })
    },    
    publishPage: function(){
      let that = this;
      this.$vs.loading();
      this.params.action = 'generate';
      axios.put("/api/blog",this.params)
      .then((data) => {
        that.$vs.loading.close();
        if(data.data.success){
          that.openAlert('success','Success');
        } else{
          that.openAlert('danger','Failed',data.messsage);
        }
        delete this.params.action;
        })
      .catch(() => { that.$vs.loading.close(); that.openAlert('danger','Failed'); })
    },
    closePopups: function(){
      this.componentKey++;
      this.popUps.popupAddActive = false;
      this.formParams = {formType:'add'};
      this.$forceUpdate();
    }
  },
  mounted() {
    this.getData();
  }
}

</script>